import { render, staticRenderFns } from "./UploadPartnerLogos.vue?vue&type=template&id=0f9cee2e&scoped=true&"
import script from "./UploadPartnerLogos.vue?vue&type=script&lang=js&"
export * from "./UploadPartnerLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cee2e",
  null
  
)

export default component.exports